import React from 'react';
import { Box, Grid } from '@material-ui/core';
import { Dictionary } from 'lodash';
import { useTranslation } from 'react-i18next';
import { groupBy, keys } from 'lodash/fp';
import { BillDetail, ListContainer, Typography } from '../../../../ui-kit';
import { AccountingItemState } from '../../../../generated/graphql';
import OrderLineDetailListRow from './OrderLineDetailListRow';
import { OrderDetails } from './types';

interface OrderBillListProps {
    keyedBills: Dictionary<OrderDetails['bills'][0]>;
    grouped: Dictionary<OrderDetails['orderLines']>;
}

const OrderBillList = ({ keyedBills, grouped }: OrderBillListProps) => {
    const { t } = useTranslation();

    const {
        [AccountingItemState.Opened]: Opened = [],
        [AccountingItemState.Canceled]: Canceled = [],
        [AccountingItemState.Paid]: Paid = [],
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [AccountingItemState.Voided]: Voided = [],
        [AccountingItemState.Moved]: Moved = [],
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [AccountingItemState.SoftRemoved]: SoftRemoved = [],
    } = grouped;

    const groupedByBillId = groupBy('billId', Paid);
    const payedBillIds = keys(groupedByBillId);

    return (
        <ListContainer>
            {Opened.length > 0 && (
                <Box>
                    <Grid item xs={12}>
                        <Typography variant='h6'>{t('Opened')}</Typography>
                    </Grid>
                    <Grid container spacing={3}>
                        {Opened.map(orderLine => (
                            <Grid item key={orderLine.id} xs={12} sm={6} lg={3}>
                                <BillDetail {...orderLine} />
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )}
            {Paid.length > 0 && (
                <Box>
                    <Grid item xs={12}>
                        <Typography variant='h6'>{t('Paid')}</Typography>
                    </Grid>
                    <Grid container spacing={3}>
                        {payedBillIds.map(billId => (
                            <OrderLineDetailListRow
                                key={billId}
                                bill={keyedBills[billId]}
                                orderLines={groupedByBillId[billId]}
                            />
                        ))}
                    </Grid>
                </Box>
            )}

            {Moved.length > 0 && (
                <Box>
                    <Grid item xs={12}>
                        <Typography variant='h6'>{t('Moved')}</Typography>
                    </Grid>
                    <Grid container spacing={3}>
                        {Moved.map(orderLine => (
                            <Grid key={orderLine.id} item xs={12} sm={6} lg={3}>
                                <BillDetail {...orderLine} />
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )}
            {Canceled.length > 0 && (
                <Box>
                    <Grid item xs={12}>
                        <Typography variant='h6'>{t('Canceled')}</Typography>
                    </Grid>
                    <Grid container spacing={3}>
                        {Canceled.map(orderLine => (
                            <Grid key={orderLine.id} item xs={12} sm={6} lg={3}>
                                <BillDetail {...orderLine} />
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )}
            {Voided.length > 0 && (
                <Box>
                    <Grid item xs={12}>
                        <Typography variant='h6'>{t('Voided')}</Typography>
                    </Grid>
                    <Grid container spacing={3}>
                        {Voided.map(orderLine => (
                            <Grid key={orderLine.id} item xs={12} sm={6} lg={3}>
                                <BillDetail {...orderLine} />
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )}
        </ListContainer>
    );
};

export default OrderBillList;
